import { Card, CardContent, makeStyles, MenuItem, Select, FormControl, InputLabel, TextField, Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FiltersInterface, activeStatus, paymentWays, periods, subscriptionTypes } from '../consts';
import { SearchByEmail } from '../SearchByEmailModal';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    display: 'flex',
    flexFlow: 'column'
  },
  filters: {
    display: 'flex',
	  justifyContent: 'space-around',
    alignContent: 'center',
    flexWrap: 'wrap'
  },
  dropDown: {
    justifyContent: 'flex-start',
    minWidth: "20vh",
  },
  idFilterContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  idFilter: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '2vh'
  },
  helper: {
    display: 'flex',
    flex: 1,
    textDecoration: 'underline',
    cursor: 'pointer',
    marginTop: theme.spacing(0),
    alignItems: 'flex-start'
  },
  searchButton: {
    marginLeft: '1vh'
  }
}));

interface Props {
  onFiltersUpdated: Function
};

const Filters = (props: Props) => {
  const classes = useStyles();
  const [subscriptionType, setSubscriptionType] = useState<String>('all');
  const [active, setActive] = useState<String>('all');
  const [paymentWay, setPaymentWay] = useState<String>('all');
  const [period, setPeriod] = useState<String>('all');
  const [filters, setFilters] = useState<FiltersInterface>({});
  const [userId, setUserId] = useState<string>('');
  const [toggleEmailModal, setToggleEmailModal] = useState<boolean>(false);

  useEffect(() => {
    props.onFiltersUpdated(filters); 
  }, [filters]);

  const handleSubscriptionTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFilters((oldFilters: FiltersInterface) => {
      const newFilters = {...oldFilters};
      if (event.target.value as string !== 'all')
        newFilters.role = event.target.value as string;
      else
        delete newFilters.role;
      return newFilters;
    });
    setSubscriptionType(event.target.value as string);
  };

  const handleActiveChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFilters((oldFilters: FiltersInterface) => {
      const newFilters = {...oldFilters};
      if (event.target.value as string !== 'all')
        newFilters.active = event.target.value as string;
      else
        delete newFilters.active;
      return newFilters;
    });
    setActive(event.target.value as string);
  };

  const handlePaymentWayChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFilters((oldFilters: FiltersInterface) => {
      const newFilters = {...oldFilters};
      if (event.target.value as string !== 'all')
        newFilters.paymentWay = event.target.value as string;
      else
        delete newFilters.paymentWay;
      return newFilters;
    });
    setPaymentWay(event.target.value as string);
  };

  const handlePeriodChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFilters((oldFilters: FiltersInterface) => {
      const newFilters = {...oldFilters};
      if (event.target.value as string !== 'all')
        newFilters.period = event.target.value as string;
      else
        delete newFilters.period;
      return newFilters;
    });
    setPeriod(event.target.value as string);
  };

  const handleUserSystemIdChange = (overrightUserId?: string) => {
    const idToProcess = !overrightUserId ? userId : overrightUserId;
    setFilters((oldFilters: FiltersInterface) => {
      const newFilters = {...oldFilters};
      if (idToProcess.length > 0)
        newFilters.userId__contains = idToProcess;
      else
        delete newFilters.userId__contains;
      return newFilters;
    })
  }

  const handleEmailValidation = (userId: number) => {
    const id = userId.toString();
    if (userId >= 0) {
      setUserId(id);
      handleUserSystemIdChange(id);
    }
    setToggleEmailModal(false);
  };

  return (
    <div className={classes.container}>
      <Card>
        <CardContent>
          <div className={classes.filters}>
            <div className={classes.idFilterContainer}>
              <div className={classes.idFilter}>
                <TextField
                  label="ID Système"
                  variant="outlined"
                  placeholder="*****"
                  onChange={(event: React.ChangeEvent<{ value: unknown }>) => setUserId(event.target.value as string)}
                  value={userId}
                  type="number"
                />
                <Button className={classes.searchButton} variant="outlined" color="primary" onClick={() => handleUserSystemIdChange()}>Rechercher</Button>
              </div>
              <div className={classes.helper} onClick={() => setToggleEmailModal(true)}>
                Recherche par e-mail
              </div>
            </div>
            <div style={{marginTop: '2vh'}}>
              <FormControl variant="outlined" className={classes.dropDown}>
                <InputLabel id="subscriptionTypeLabel">Type d'abonnement</InputLabel>
                <Select
                  labelId="subscriptionTypeLabel"
                  id="subscriptionTypeSelect"
                  value={subscriptionType}
                  onChange={handleSubscriptionTypeChange}
                  label="Type d'abonnement"
                  disabled={subscriptionTypes.length === 0}
                >
                  {subscriptionTypes.map((curType, i) =>
                    <MenuItem key={i} value={curType.value}>{curType.displayValue}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </div>
            <div style={{marginTop: '2vh'}}>
              <FormControl variant="outlined" className={classes.dropDown}>
                <InputLabel id="activeLabel">Actif</InputLabel>
                <Select
                  labelId="activeLabel"
                  id="activeSelect"
                  value={active}
                  onChange={handleActiveChange}
                  label="Active"
                >
                  {activeStatus.map((activeStatus, i) =>
                    <MenuItem key={i} value={activeStatus.value}>{activeStatus.displayValue}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </div>
            <div style={{marginTop: '2vh'}}>
              <FormControl variant="outlined" className={classes.dropDown}>
                <InputLabel id="paymentWayLabel">Moyen de paiement</InputLabel>
                <Select
                  labelId="paymentWayLabel"
                  id="paymentWaySelect"
                  value={paymentWay}
                  onChange={handlePaymentWayChange}
                  label="Moyen de paiement"
                >
                  {paymentWays.map((pw, i) =>
                    <MenuItem key={i} value={pw.value}>{pw.displayValue}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </div>
            <div style={{marginTop: '2vh'}}>
              <FormControl variant="outlined" className={classes.dropDown}>
                <InputLabel id="periodLabel">Périodicité</InputLabel>
                <Select
                  labelId="periodLabel"
                  id="periodSelect"
                  value={period}
                  onChange={handlePeriodChange}
                  label="Périodicité"
                >
                  {periods.map((pw, i) =>
                    <MenuItem key={i} value={pw.value}>{pw.displayValue}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </div>
          </div>
          {toggleEmailModal &&
            <SearchByEmail
              open={toggleEmailModal}
              onClose={() => setToggleEmailModal(false)}
              onRequestClose={handleEmailValidation}
              onUserSelected={() => console.log('keske jfou lo')}
            />
          }
        </CardContent>
      </Card>
    </div>
  );
}

export default Filters;